import React, { useMemo, useState } from 'react';

import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { Button } from '@bringg/react-components';
import { PrivilegeTypes, ResponseItem } from '@bringg/types';
import { DetailedCellProps } from '@bringg-frontend/monitoring';

import { useStores } from 'bringg-web/recipes';
import { assignDriverValidator } from 'bringg-web/services/tasks/assign-driver-validator';
import { useHasAccess } from 'bringg-web/utils/privileges';
import useOrderExplorerTranslations from '../../../../use-order-explorer-translations';
import UserAssignerTool from '../../../../../shared/components/user-assigner-tool';

import styles from './driver-cell.module.scss';

const DriverCell = ({ row }: DetailedCellProps<ResponseItem>) => {
	const task = getRootEnv().dashboardSdk.sdk.v2.tasks.get(row.id);
	const { user_id } = task;
	const allowAssignDriverToTask = useHasAccess(PrivilegeTypes.ASSIGN_DRIVER_TO_TASK);
	const { unassigned } = useOrderExplorerTranslations();
	const [userAssignerModalState, setUserAssignerModalState] = useState<boolean>(false);
	const {
		driversStore: { fetchByTeam, get: getDriverById }
	} = useStores();

	const driver = getDriverById(user_id);
	const text = driver?.name || unassigned;

	const isDisabled = useMemo(() => {
		const assignDriverValidation = assignDriverValidator.isAllowedToAssignSelectedTasks(
			[task],
			allowAssignDriverToTask
		);

		return !assignDriverValidation.canAssign || !assignDriverValidation.assignableTasks.length;
	}, [allowAssignDriverToTask]);

	return (
		<div className={styles.driverCell}>
			{userAssignerModalState && (
				<UserAssignerTool selectedTasks={[task]} closeModal={() => setUserAssignerModalState(false)} />
			)}
			<Button
				type="link"
				onClick={async () => {
					await fetchByTeam(task.team_ids[0]);
					setUserAssignerModalState(true);
				}}
				className={styles.driverButton}
				disabled={isDisabled}
			>
				{text}
			</Button>
		</div>
	);
};

export default DriverCell;
